// Group the audited supplier products for discovery without hiding or unpublishing them.
const family = new Set(['soft-charcoal','clay','taupe','dusty-blue','oatmeal-beige','heather-gray','dusty-pink','ivory-cream','rosewood','soft-cream','sage-green'].map(color => `${color}-baby-beanie-aop`));
function familyCard(card) {
  return [...card.querySelectorAll('a[href]')].some(a => family.has(new URL(a.href, location.href).pathname.split('/products/')[1]?.split('/')[0]));
}
function label(card) {
  if (card.dataset.beanieFamilyCard) return;
  card.dataset.beanieFamilyCard = 'true';
  // Grouped discovery always enters Ivory Cream; direct product links retain their color.
  const entryUrl = `${window.Shopify?.routes?.root || '/'}products/ivory-cream-baby-beanie-aop`;
  card.querySelectorAll('a[href]').forEach(link => {
    if (family.has(new URL(link.href, location.href).pathname.split('/products/')[1]?.split('/')[0])) link.href = entryUrl;
  });
  card.querySelectorAll('h3, [data-product-title], .product-card__title').forEach(heading => {
    const link = heading.querySelector('a');
    (link || heading).textContent = 'Custom Pet Portrait Baby Beanie';
  });
  card.querySelectorAll('a[aria-label]').forEach(link => {
    if (link.getAttribute('aria-label').includes('Custom Pet Portrait Baby Beanie')) link.setAttribute('aria-label', 'Custom Pet Portrait Baby Beanie');
  });
  card.querySelectorAll('quick-add-component, .quick-add').forEach(node => node.remove());
  if (!card.querySelector('[data-beanie-colors-link]')) {
    const link = document.createElement('a'); link.dataset.beanieColorsLink = '';
    link.href = entryUrl;
    link.textContent = 'Explore all 11 colors →'; link.style.display = 'block'; link.style.paddingBlock = '.5rem';
    (card.querySelector('.product-card__content') || card).append(link);
  }
}
const processing = new WeakSet();
async function groupCollection(root) {
  // Shop All remains native until a scalable pre-pagination grouping source is approved.
  // Do not fetch its entire catalog to collapse cards after first paint.
  if (location.pathname.replace(/\/$/, '') === '/collections/all') return;
  const meta = root.querySelector('[data-beanie-pagination]');
  if (root.hasAttribute('data-beanie-server-grouped')) {
    root.querySelectorAll('product-card').forEach(card => { if (familyCard(card)) label(card); });
    return;
  }
  if (processing.has(root) || meta?.dataset.processed) return;
  const grid = root.querySelector('ul.product-grid');
  if (!meta || !grid) return;
  processing.add(root);
  const pageCount = Number(meta.dataset.pages);
  const currentPage = Number(meta.dataset.page);
  const pageSize = Number(meta.dataset.perPage) || 24;
  const snapshot = location.pathname + location.search;
  try {
    if (pageCount > 30) return; // Leave native results intact rather than partially grouping.
    const pages = await Promise.all(Array.from({ length: pageCount }, async (_, i) => {
      const page = i + 1;
      if (page === currentPage) return [...grid.querySelectorAll(':scope > li[data-product-id]')];
      const url = new URL(location.href); url.searchParams.set('page', String(page)); url.searchParams.set('section_id', root.getAttribute('section-id'));
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw Error('Collection page could not be read');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const remote = doc.querySelector('[data-beanie-collection] ul.product-grid');
      if (!remote) throw Error('Native collection markup unavailable');
      return [...remote.querySelectorAll(':scope > li[data-product-id]')];
    }));
    if (!root.isConnected || snapshot !== location.pathname + location.search) return;
    const all = pages.flat();
    if (!all.some(familyCard)) { meta.dataset.processed = 'true'; return; }
    let seen = false;
    const ids = new Set();
    const grouped = all.filter(card => {
      if (ids.has(card.dataset.productId)) return false;
      ids.add(card.dataset.productId);
      if (!familyCard(card)) return true;
      if (seen) return false;
      seen = true; label(card); return true;
    });
    root.dataset.beanieGrouped = 'true';
    meta.dataset.processed = 'true';
    root.querySelectorAll('.products-count-wrapper').forEach(node => { node.textContent = `${grouped.length} product designs`; });
    const results = root.querySelector('#ResultsList');
    results?.querySelectorAll('nav.pagination').forEach(nav => nav.remove());
    const nav = document.createElement('nav'); nav.className = 'pagination'; nav.setAttribute('aria-label', 'Collection pages');
    const totalPages = Math.ceil(grouped.length / pageSize);
    function show(page, updateUrl) {
      const selectedPage = Math.max(1, Math.min(page, totalPages));
      grid.replaceChildren(...grouped.slice((selectedPage - 1) * pageSize, selectedPage * pageSize));
      nav.replaceChildren();
      for (let i = 1; i <= totalPages; i++) {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = String(i);
        button.style.margin = '.4rem'; button.style.padding = '.6rem 1rem';
        if (i === selectedPage) button.setAttribute('aria-current', 'page');
        button.addEventListener('click', () => { show(i, true); results?.scrollIntoView({ block: 'start' }); }); nav.append(button);
      }
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('page', String(selectedPage)); history.replaceState(history.state, '', url); }
    }
    if (totalPages > 1) grid.insertAdjacentElement('afterend', nav);
    show(currentPage, false);
  } catch (error) {
    // Keep all original native cards/pagination on any incomplete read.
    console.warn('Baby beanie collection grouping deferred:', error.message);
  } finally { processing.delete(root); }
}
function scan() {
  document.querySelectorAll('[data-beanie-collection]').forEach(groupCollection);
  document.querySelectorAll('.shop-all-carousel, .collection-hub__products').forEach(row => {
    let seen = false;
    row.querySelectorAll('product-card').forEach(card => {
      if (!familyCard(card)) return;
      if (seen) card.remove(); else { seen = true; label(card); }
    });
  });
}
let queued = false;
new MutationObserver(() => {
  if (queued) return; queued = true;
  requestAnimationFrame(() => { queued = false; scan(); });
}).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
scan();
